import React from "react"

export default function Search() {
  return (
    <symbol id="svg-search" viewBox="0 0 36 36">
      <path
        fill="currentColor"
        d="M28.1 25.9l-4.2-4.2c1-1.5 1.6-3.4 1.6-5.3 0-5-4-9-9-9s-9 4-9 9 4 9 9 9c1.8 0 3.6-.6 5.2-1.6l4.2 4.2c.3.3.8.4 1.1.4s.7-.1 1.1-.4c.5-.5.5-1.5 0-2.1zM16.5 10.5c3.3 0 6 2.7 6 6 0 1.6-.6 3.1-1.8 4.2-1.1 1.1-2.6 1.8-4.2 1.8-3.3 0-6-2.7-6-6s2.7-6 6-6z"
      />
    </symbol>
  )
}
